<template>
  <AdminMachineModels :lockedFilters="{ SupplierIdList: [$route.params.supplierId] }" hideSupplierFilter />
</template>


<script>
import AdminMachineModels from "@/views/pim/machinemodels/AdminMachineModels.vue";


export default {
  name: "ViewSupplierModelList",
  props: {},
  components: {
    AdminMachineModels,
  },

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>